/** Children in a row that wraps: chips, buttons, a title and its count. */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import type { Gap } from './Stack'
import s from './Layout.module.css'

export function Inline({
  gap = 'sm',
  align = 'center',
  justify = 'start',
  wrap = true,
  children,
}: {
  gap?: Gap
  align?: 'start' | 'center' | 'end' | 'baseline'
  justify?: 'start' | 'end' | 'between'
  wrap?: boolean
  children: ReactNode
}) {
  return <div className={cx(s.inline, s[`gap-${gap}`], s[`align-${align}`], s[`justify-${justify}`], !wrap && s.nowrap)}>{children}</div>
}
